import { render, staticRenderFns } from "./suanfaHeader.vue?vue&type=template&id=42b48e2a&"
import script from "./suanfaHeader.vue?vue&type=script&lang=js&"
export * from "./suanfaHeader.vue?vue&type=script&lang=js&"
import style0 from "./suanfaHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports